module.exports = __webpack_public_path__ + "static/desktop_mockup-3024d24236dbc92366d1aa24dd298784.png";